export default "__VITE_ASSET__abf1f5a8__"